export default __webpack_public_path__ + "static/media/Silver.f92f3b3e.svg";